import React from 'react'
import styles from './style.module.scss'

/**
 * React component to build tables
 * @param {HTMLElement} children
 * @param {Array<string>} headers
 */
export const Table = (props => {
  return (
    <div className="table-responsive">
      {
        props.headers ?
        <table className={`table ${styles.table}`}>
          <thead>
            <tr>
              { props.headers.map((h, i) => <th key={h+i} scope="col">{h}</th>) }
            </tr>
          </thead>
          <tbody>
            {props.children}
          </tbody>
        </table>
        : console.error("Error: It's not possible to build a table without headers. \r\n    in Table (at src/_components/Table/index.jsx:17)")
      }
    </div>
  )
})